import dayjsTZ from "../../../utils/dayjs";

/** Break length in hours from ["HH:mm", "HH:mm"]. */
export const getBreakHours = (breakTime) => {
  if (!Array.isArray(breakTime) || breakTime.length < 2) return 0;
  const [start, end] = breakTime;
  if (!start || !end) return 0;
  const diff = dayjsTZ(end, "HH:mm").diff(dayjsTZ(start, "HH:mm"), "hours", true);
  return Number.isFinite(diff) && diff > 0 ? diff : 0;
};

/**
 * Gross / working / paid hours for a clocking row.
 * Break applies when shift > 4h (same rule as payroll).
 * Paid break: working = gross − break, paid = gross.
 * Unpaid break: working = paid = gross − break.
 */
export const getShiftHoursBreakdown = ({
  clockInDate,
  clockOutDate,
  breakTime,
  isBreakTimePaid,
}) => {
  if (!clockInDate || !clockOutDate) {
    return {
      grossHours: 0,
      breakHours: 0,
      workingHours: 0,
      paidHours: 0,
      breakApplied: false,
    };
  }

  const grossHours = dayjsTZ(clockOutDate).diff(
    dayjsTZ(clockInDate),
    "hours",
    true
  );
  const configuredBreak = getBreakHours(breakTime);
  const breakApplied = configuredBreak > 0 && grossHours > 4;
  const breakHours = breakApplied ? configuredBreak : 0;
  const workingHours = Math.max(0, grossHours - breakHours);
  const paidHours = isBreakTimePaid ? grossHours : workingHours;

  return {
    grossHours: Number(grossHours.toFixed(2)),
    breakHours: Number(breakHours.toFixed(2)),
    workingHours: Number(workingHours.toFixed(2)),
    paidHours: Number(paidHours.toFixed(2)),
    breakApplied,
  };
};
